class BonusPoints {
  constructor() {
    this.init();
    this.dialogInfo = {};
    this.PopupController = "";
    this.accountPoints = 0;
    this.pointTasks = [];
  }
  init() {
    // if (customer_id) {
    window.VOGRACE.eventBus.on("popup:open", (_, __, res) => {
      this.PopupController = res;
    });
    if (customer_id) {
      VogUtils.showGlobalLoading();
      this.currentAccountInfo().finally(() => {
        VogUtils.hideGlobalLoading();
      });
    }
    $vog("#points-works-link").on("click", function (e) {
      if (!customer_id) {
        window.VOGRACE.showRegisterPopup();
      } else {
        window.location.href = 'https://vograce.com/pages/new-customer'
      }
    });
    this.getPoints();
    this.getEarnPointsBtn();
    this.getLoginorSignup();
    const viewportWidth = $vog(window).width();
    if (viewportWidth < 768) {
       $vog("#notLogin").css(
        "background",
        `url(https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_300.png?v=1750932067)`
      );
    }
    window.VOGRACE.eventBus.on("popup:close", (popupId) => {
      if (popupId === "#pointsDialog") {
        $('[id^="couponDetailItem"]').addClass("counter-detail-hide");
      }
    });
  }

  getEarnPointsBtn() {
    const _this = this;
    $vog(document).on("click", ".earn-points-img-btn", function (e) {
      let index = $(e.currentTarget).data("index");
      console.log(index, "我是11111111");
      VogUtils.buttonLoadingshow(`#earnPointsBtn-${index}`)
      if (index == "1") {
        if (!customer_id) {
          window.VOGRACE.showRegisterPopup();
        } else {
          window.location.href = location.origin + "/account";
        }
        VogUtils.buttonLoadinghide(`#earnPointsBtn-${index}`)
      } else if (index == "2") {
        if (!customer_id) {
          window.VOGRACE.showLoginPopup();
          VogUtils.buttonLoadinghide(`#earnPointsBtn-${index}`)
        } else {
          _this.getPointsTasks('',index);
        }
      } else if (index == "3") {
        window.location.href = "https://vograce.com/collections/all-products?_pos=1&_psq=all&_ss=e&_v=1.0"
         VogUtils.buttonLoadinghide(`#earnPointsBtn-${index}`)
      } else if (index == "4") {
        if (!customer_id) {
          window.VOGRACE.showLoginPopup();
        } else {
          window.location.href = "https://vograce.com/pages/membership-center";
        }
         VogUtils.buttonLoadinghide(`#earnPointsBtn-${index}`)
      }
    });
  }
  // 用户基本信息
  async currentAccountInfo() {
    const memberImg = {
      // non_registered: 'https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_414_5.png?v=1750666431',
      regular_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_427.png?v=1750830793", //普通
      silver_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_428.png?v=1750830799", //银卡
      gold_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Untitled_4.png?v=1750669032", //金卡
      black_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_379.png?v=1750830781",
    };
    const memberBg = {
      // non_registered: 'https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_414_5.png?v=1750666431',
      regular_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_414_3.png?v=1750666413",
      silver_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_414_4.png?v=1750666420",
      gold_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_414_2.png?v=1750666397",
      black_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_414_5.png?v=1750666431",
    };
    const memberImgH5 = {
      regular_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_430.png?v=1750931962",
      silver_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_431.png?v=1750931962",
      gold_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_429.png?v=1750931962",
      black_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_423.png?v=1750931962",
    };
    const memberBgH5 = {
      regular_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_424.png?v=1750932694",
      silver_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_425.png?v=1750932694",
      gold_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Ellipse_8.png?v=1750932787",
      black_member:
        "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Frame_426.png?v=1750932694",
    };
    try {
      const res = await VogUtils.getFactory({
        url: "/account/currentAccountInfo",
        method: "GET",
      });
      this.accountPoints = res.points;
      $vog("#accountPoints").text(Math.trunc(Number(res.points)));
      $vog("#full_name").text(`Hi，${res.full_name}`);
      if (res.points_end_time) {
        $vog("#expirationDate").text(`Expiration Date: ${res.points_end_time}`);
        $vog("#expirationDate").attr("data-visibility", "visible");
      }
      const viewportWidth = $vog(window).width();
      let imgUrl = memberImg[res.customer_level];
      let imgBgUrl = memberBg[res.customer_level];
      if (viewportWidth < 768) {
        imgUrl = memberImgH5[res.customer_level];
        imgBgUrl = memberBgH5[res.customer_level];
        $vog("#logged-h5").attr("data-visibility", "visible");
        $vog("#logged-pc").attr("data-visibility", "hidden");
        $vog("#accountPointsH5").text(Math.trunc(Number(res.points)));
        if (res.points_end_time) {
          $vog("#expirationDateH5").text(`Expiration Date: ${res.points_end_time}`);
          $vog("#expirationDateH5").attr("data-visibility", "visible");
       }
      }
      console.log("可视区域宽度:", viewportWidth);
      $vog("#memberImage").attr("src", imgUrl);
      $vog(".bonus-points-frenzys-info-logged").css(
        "background",
        `url(${imgBgUrl})`
      );
      if (res.customer_level === "black_member") {
        $vog(".bonus-points-frenzys-info-logged").css("color", "#ffffff");
      }
      $vog("#notLogin").attr("data-visibility", "hidden");
      $vog("#logged").attr("data-visibility", "visible");
    } catch (error) {
      console.log(error);
    }
  }
  async getPointsTransactions(id) {
    try {
      const data = { limit: 30 };
      const res = await VogUtils.getFactory({
        url: "/account/getPointsTransactions",
        method: "GET",
        data,
      });
      console.log(res, "Points History 按钮被点击了");
      const listData = res.list.data;
      let html = "";
      listData.forEach((item, index) => {
        html += this.historyHtml(item, index);
      });
      $vog("#popup-pointsHistory").html(html);
      VogUtils.buttonLoadinghide(id)
      this.PopupController.open();
    } catch (error) {
      console.log(error);
      // 增强错误处理
      const errorMessage =
        error.data?.message || error.message || "something_went_wrong";
      VogUtils.buttonLoadinghide(id)
      VogUtils.showMessage(errorMessage, "default");
    }
  }
  historyHtml(item) {
    return `
        <div class="scrollable-item">
            <div>
                <div class="history_title">${item.type_str}</div>
                <div class="history_points"> ${item.balance_points}</div>
            </div>
            <div class="history_inorout">${
              item.in == "0.00" ? "-" + item.out : "+ " + item.in
            }</div>
        </div> `;
  }

  async getPointsTasks(data,buttonIndex) {
    $vog("#popup-rewards-lists").attr("data-visibility", "hidden");
    $vog("#popup-pointsHistory").attr("data-visibility", "hidden");
    $vog("#popup-taskLists").attr("data-visibility", "visible");
    $vog("#popup_title").text("Ways to Earn");
    try {
      const res = await VogUtils.getFactory({
        url: "/getPointsTasks",
        method: "GET",
        data,
      });
      let html = "";
      res.forEach((item, index) => {
        html += this.pointsTaskHtml(item, index);
      });
      $vog("#popup-taskLists").html(html);
      this.pointTasks = res;
      const _this = this;
      $vog("#popup_accountPoints").text(
        `Your points:${_this.accountPoints || 0}`
      );
      $vog("#popup-taskLists .scrollable-item .share-btn")
        .off()
        .on("click", (e) => {
          let index = $(e.currentTarget).data("index");
          console.log(index, "index");
          _this.shareButtonEvent(_this.pointTasks[index], index);
        });
      const popup = window.VOGRACE.popupMap.get("#pointsDialog");
      VogUtils.buttonLoadinghide(`#earnPointsBtn-${buttonIndex}`)
      popup.open();
    } catch (error) {
      console.log("API Error:", error);
      // 增强错误处理
      const errorMessage =
        error.data?.message || error.message || "something_went_wrong";
      VogUtils.buttonLoadinghide(`#earnPointsBtn-${buttonIndex}`)
      VogUtils.showMessage(errorMessage, "default");
      console.log(error);
    }
  }
  async shareButtonEvent(item, index) {
    console.log(item, "item");
    window.open(item.share_url, "_blank");
    const data = { id: item.id };
    try {
      const res = await VogUtils.fetchFactory({
        url: "/account/finishedTask",
        method: "POST",
        data,
        contentType: "multipart/form-data",
      });
      this.getPointsTasks();
      this.currentAccountInfo();
      location.reload()
    } catch (error) {
      console.log(error);
    }
  }
  getLoginorSignup() {
    $vog("#btnSignUp,#btnLogIn").on("click", function (e) {
      if ($(this).attr("id") === "btnSignUp") {
        window.VOGRACE.showRegisterPopup();
      } else {
        window.VOGRACE.showLoginPopup();
      }
    });
  }
  getPoints() {
    const _this = this;
    $vog("#pointsHistory, #yourRewards").on("click", async function (e) {
      _this.PopupController.close();
      e.preventDefault(); // 阻止默认行为
      // // 判断点击的是哪个按钮
      $vog("#popup-taskLists").attr("data-visibility", "hidden");
      $vog("#popup_accountPoints").text( `Your points:${_this.accountPoints || 0}`);
      if ($(this).attr("id") === "pointsHistory") {
        VogUtils.buttonLoadingshow('#pointsHistory')
        $vog("#popup-rewards-lists").attr("data-visibility", "hidden");
        $vog("#popup-pointsHistory").attr("data-visibility", "visible");
        $vog("#popup_title").text("Points History");
        console.log("Points History 按钮被点击了");
        _this.getPointsTransactions('#pointsHistory')
      } else if ($(this).attr("id") === "yourRewards") {
        VogUtils.buttonLoadingshow("#yourRewards")
        $vog("#popup-pointsHistory").attr("data-visibility", "hidden");
        $vog("#popup-rewards-lists").attr("data-visibility", "visible");
        $vog("#popup_title").text("Your Rewards");
        console.log("Your Rewards 按钮被点击了");
        _this.getCouponLists("#yourRewards");
      }
    });
  }
  // 优惠信息
  async getCouponLists(id) {
    try {
      const _this = this;
      const data = { limit: 30, page: 1 };
      const res = await VogUtils.getFactory({
        url: "/account/getCouponList",
        method: "GET",
        data,
      });
      let lists = res.list?.data;
      $vog("#rewards-lists_item").html("");
      $vog("#cannot-lists_item").html("");
      lists.forEach((item) => {
        if (item.is_used == 1 || item.is_expire) {
          $vog("#cannot-lists_item").append(this.getCouponItem(item));
        } else {
          $vog("#rewards-lists_item").append(this.getCouponItem(item));
        }
      });
      console.log($vog(".coupon-lists_item").length, "xixiixixi");
      $vog(document).on("click", ".coupon-lists_item", function (e) {
        _this.setCouponDetail(lists, $(e.currentTarget).data("id"));
      });
       VogUtils.buttonLoadinghide(id)
      _this.PopupController.open();
    } catch (e) {
      console.log(error);
      // 增强错误处理
      const errorMessage =
        error.data?.message || error.message || "something_went_wrong";
      VogUtils.buttonLoadinghide(id)
      VogUtils.showMessage(errorMessage, "default");
    }
  }
  setCouponDetail(lists, id) {
    let _this = this;
    let selectedItem = lists.find((item) => item.id == id);
    const $detail = $vog("#couponDetailItem" + selectedItem.id);
   // 隐藏其他所有 couponDetailItem
    $vog('[id^="couponDetailItem"]').addClass("counter-detail-hide");
    $vog('[id^="arrow"]').addClass("right")
    $vog('[id^="arrow"]').removeClass("down")

    // 只显示当前选中项
    $detail.removeClass("counter-detail-hide");
    $vog("#arrow" + selectedItem.id).addClass("down")
    $vog("#arrow" + selectedItem.id).removeClass("right")
    $vog(document).on("click", ".coupon-browser-loy-button", function (e) {
      let type = $(this).attr("aria-label");
      if (!type) return;
      _this.copyCode($(this).data("code"));
    });
  }

  pointsTaskHtml(item, index) {
    return `
      <div class="scrollable-item">
        <div class="task-item ${
          item.is_finished ? "task-half-opacity" : ""
        }" aria-label="Signup">
          <div class="task-item_icon">
            <div class="task-item_icon-image">
               ${item.icon_html}
            </div>
            <div>
              <div class="task-item_name">${item.name}</div>
              <div class="task-item_description">${item.description}</div>
            </div>
          </div>
          ${
            item.is_finished
              ? `<div class="tick"></div>`
              : item.button_text &&
                `<button class="share-btn loy-button loy-button-sm loy-button-main" style="background-color: #F5A800;width: 96px" data-index="${index}">${item.button_text}</button>`
          }
        </div>
      </div>
    `;
  }
  getCouponItem(item) {
    return `
      <div>
        <button class="scrollable-item coupon-lists_item" aria-label="${
          item.name
        }" data-id="${item.id}">
          <div class="task-item"> 
            <div class="flex">
             <svg class="li-img" height="30" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="8.07 12 33.86 26">
              <path d="M 10.068359 11.998047 C 8.9633594 11.998047 8.0683594 12.893047 8.0683594 13.998047 L 8.0683594 19.501953 C 8.0683594 19.785953 8.3019375 19.999 8.5859375 20 C 11.723937 20.008 14 22.108 14 25 C 14 27.891 11.725891 29.992 8.5878906 30 C 8.3038906 30.001 8.0683594 30.216 8.0683594 30.5 L 8.0683594 36 C 8.0683594 37.105 8.9633594 38 10.068359 38 L 39.931641 38 C 41.035641 38 41.932641 37.105953 41.931641 36.001953 L 41.931641 30.498047 C 41.931641 30.214047 41.698062 30.001 41.414062 30 C 38.276062 29.992 36 27.892 36 25 C 36 22.109 38.274109 20.007047 41.412109 19.998047 C 41.696109 19.997047 41.931641 19.782047 41.931641 19.498047 L 41.931641 13.998047 C 41.931641 12.893047 41.036641 11.998047 39.931641 11.998047 L 10.068359 11.998047 z M 10.068359 13 L 30 13 L 30 17.5 C 30 17.776 30.224 18 30.5 18 C 30.776 18 31 17.776 31 17.5 L 31 13 L 39.931641 13 C 40.483641 13 40.931641 13.448 40.931641 14 L 40.931641 19.015625 C 37.464641 19.229625 35 21.681 35 25 C 35 28.319 37.465641 30.770375 40.931641 30.984375 L 40.931641 36 C 40.931641 36.552 40.483641 37 39.931641 37 L 31 37 L 31 32.5 C 31 32.224 30.776 32 30.5 32 C 30.224 32 30 32.224 30 32.5 L 30 37 L 10.068359 37 C 9.5163594 37 9.0683594 36.552 9.0683594 36 L 9.0683594 30.984375 C 12.535359 30.770375 15 28.319 15 25 C 15 21.681 12.535359 19.229625 9.0683594 19.015625 L 9.0683594 14 C 9.0683594 13.448 9.5163594 13 10.068359 13 z M 30.5 22 C 30.224 22 30 22.224 30 22.5 L 30 27.5 C 30 27.776 30.224 28 30.5 28 C 30.776 28 31 27.776 31 27.5 L 31 22.5 C 31 22.224 30.776 22 30.5 22 z"></path>
             </svg> 
             <div>
              <div class="task-item_name">${item.name}</div> 
              <div class="less-color">${window.i18n.t("use")} ${
      item.points_used
    } ${window.i18n.t("points")}</div>
              </div>
            </div>
             ${
               item.is_used || item.is_expire
                 ? ``
                 : `<div id="arrow${item.id}" class="arrow right"></div>`
             }
          </div>
        </button>
        <div id="couponDetailItem${
          item.id
        }" class="counter-container counter-detail-hide">
            <div class="counter-container-title">
                <div>
                    <svg class="li-img" height="30" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="8.07 12 33.86 26">
                    <path d="M 10.068359 11.998047 C 8.9633594 11.998047 8.0683594 12.893047 8.0683594 13.998047 L 8.0683594 19.501953 C 8.0683594 19.785953 8.3019375 19.999 8.5859375 20 C 11.723937 20.008 14 22.108 14 25 C 14 27.891 11.725891 29.992 8.5878906 30 C 8.3038906 30.001 8.0683594 30.216 8.0683594 30.5 L 8.0683594 36 C 8.0683594 37.105 8.9633594 38 10.068359 38 L 39.931641 38 C 41.035641 38 41.932641 37.105953 41.931641 36.001953 L 41.931641 30.498047 C 41.931641 30.214047 41.698062 30.001 41.414062 30 C 38.276062 29.992 36 27.892 36 25 C 36 22.109 38.274109 20.007047 41.412109 19.998047 C 41.696109 19.997047 41.931641 19.782047 41.931641 19.498047 L 41.931641 13.998047 C 41.931641 12.893047 41.036641 11.998047 39.931641 11.998047 L 10.068359 11.998047 z M 10.068359 13 L 30 13 L 30 17.5 C 30 17.776 30.224 18 30.5 18 C 30.776 18 31 17.776 31 17.5 L 31 13 L 39.931641 13 C 40.483641 13 40.931641 13.448 40.931641 14 L 40.931641 19.015625 C 37.464641 19.229625 35 21.681 35 25 C 35 28.319 37.465641 30.770375 40.931641 30.984375 L 40.931641 36 C 40.931641 36.552 40.483641 37 39.931641 37 L 31 37 L 31 32.5 C 31 32.224 30.776 32 30.5 32 C 30.224 32 30 32.224 30 32.5 L 30 37 L 10.068359 37 C 9.5163594 37 9.0683594 36.552 9.0683594 36 L 9.0683594 30.984375 C 12.535359 30.770375 15 28.319 15 25 C 15 21.681 12.535359 19.229625 9.0683594 19.015625 L 9.0683594 14 C 9.0683594 13.448 9.5163594 13 10.068359 13 z M 30.5 22 C 30.224 22 30 22.224 30 22.5 L 30 27.5 C 30 27.776 30.224 28 30.5 28 C 30.776 28 31 27.776 31 27.5 L 31 22.5 C 31 22.224 30.776 22 30.5 22 z"></path>
                    </svg>
                </div> 
                <div>
                    <div class="couponDetail-name">${item.name}</div> 
                    <div class="less-color">${window.i18n.t("spent")} ${
      item.points_used
    } ${window.i18n.t("points")}</div>
                </div>
            </div>
            <div class="counter-container-desc">
                <span>${window.i18n.t(
                  "use_this_discount_code_on_your_next_order"
                )}</span>
            </div>
            <div class="copy-coupon center-align">
                <input class="coupon-code txt-field ba-loy-rounded center-align full-width" type="text" tabindex="-1" value="${
                  item.coupon_code
                }" disabled>
                <button class="coupon-browser-loy-button" aria-label="Copy coupon code" data-code="${
                  item.coupon_code
                }"></button>
            </div>  
            <div class="panel-footer"></div><div class="txt-info">${window.i18n
              .t("reward_expires_on_")
              .replace("{{end_as}}", item.end_as)}</div>
        </div>
      </div>`;
  }
  copyCode(text) {
    navigator.clipboard.writeText(text).then(() => {
      layer.msg(window.i18n.t("copy_successfully"));
    });
  }
  getPointLiHtml(item) {
    return `
      <li class="px-2 sm:py-4">
        <div class="flex items-center">
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate dark:text-white">${
              item.type_str
            }</p>
            <p class="text-sm text-gray-500 truncate dark:text-gray-400">${
              item.balance_points
            }</p>
          </div>
          <div class="inline-flex items-center text-sm text-gray-400 dark:text-white">
            ${item.in == "0.00" ? "-" + item.out : "+ " + item.in}
          </div>
        </div>
      </li>`;
  }
}

VogUtils.DOMready(() => {
  new BonusPoints();
});